export default (props, vars) =>
  !!props?.['preAvailableTimes']?.['availableTimes'];
